import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import App from './App';

import DataContextProvider from './Context/DataContextProvider';

ReactDOM.render(
  <DataContextProvider>
    <HashRouter>
    <App/>
    </HashRouter>
  </DataContextProvider>,
  document.getElementById('root')
);


